import React from "react";

import translationsFr from "./translations/fr.json";
import translationsDe from "./translations/de.json";
import translationsEs from "./translations/es.json";
import flagFr from "./assets/img/flags/fr.svg";
import flagDe from "./assets/img/flags/de.svg";
import flagEs from "./assets/img/flags/es.svg";
import flagIt from "./assets/img/flags/it.svg";
import flagPt from "./assets/img/flags/pt.svg";
import flagEn from "./assets/img/flags/en.svg";
import flagNl from "./assets/img/flags/nl.svg";
import flagBe from "./assets/img/flags/be.svg";
import flagLu from "./assets/img/flags/lu.svg";
import flagAt from "./assets/img/flags/at.svg";
import flagDk from "./assets/img/flags/dk.svg";
import flagNo from "./assets/img/flags/no.svg";
import flagSe from "./assets/img/flags/se.svg";
import flagCh from "./assets/img/flags/ch.svg";
import { didomiConfig, linkPrivacy } from "./config";

export const dictionnary = {
  fr: translationsFr,
  de: translationsDe,
  es: translationsEs,
  it: false,
  pt: false,
  en: false,
  nl: false,
};

export const languageList = ["fr", "de", "es", "it", "pt", "en", "nl"];

export const flags = {
  fr: flagFr,
  de: flagDe,
  es: flagEs,
  it: flagIt,
  pt: flagPt,
  en: flagEn,
  uk: flagEn,
  nl: flagNl,
  be: flagBe,
  lu: flagLu,
  at: flagAt,
  dk: flagDk,
  se: flagSe,
  no: flagNo,
  ch: flagCh,
};

export const languages = {
  fr: "frenchHp",
  de: "germanHP",
  es: "spainHp",
  it: "italianHp",
  pt: "portugueseHp",
  en: "englishHP",
  nl: "dutchHp",
};

export const corporateSiteLink = {
  fr: "https://office.autobiz.com/contact/",
  en: "https://corporate.autobiz.com/en/contact-us",
  es: "https://office.autobiz.com/es/contacto/",
  pt: "https://corporate.autobiz.com/pt/contactos",
  it: "https://office.autobiz.com/it/contatti/",
  de: "https://corporate.autobiz.com/de/kontakt",
  nl: "https://corporate.autobiz.com/nl/contact",
};
export const contactUsLink = {
  fr: "https://corporate.autobiz.com/contact",
  en: "https://corporate.autobiz.com/en/contact-us",
  de: "https://corporate.autobiz.com/de/kontakt",
  es: "https://corporate.autobiz.com/es/contactos",
  pt: "https://corporate.autobiz.com/pt/contactos",
  it: "https://corporate.autobiz.com/it",
};

export const LanguageContext = React.createContext(
  dictionnary.fr, // default value
);

// @ts-ignore
export const getFlag = (language: any) => flags[language];

export const selectRightLanguageToApply = () => {
  const storedLanguage = localStorage.getItem("applanguage");
  const browserLanguage = window.navigator.language?.slice(0, 2);
  if (isLanguageValid(storedLanguage)) return storedLanguage;
  if (isLanguageValid(browserLanguage)) return browserLanguage;
  return "en";
};

const isLanguageValid = (language: any) => languageList.includes(language);

export const didomiSetConfig = (language: any) => {
  // @ts-ignore
  didomiConfig.config.app.privacyPolicyURL = `${window.location.host}/${language}/${linkPrivacy[language]}`;
  // @ts-ignore
  didomiConfig.config.languages = {
    enabled: [language],
    default: language,
  };
  return didomiConfig;
};
export const getCurrencyByCountry = (country: any) => {
  switch (country) {
    case "uk":
      return "£";
    default:
      return "€";
  }
};
